import React, { useContext } from "react";
import { Modal } from "react-bootstrap";
import GroupModal from "./GroupModal";
import BootstrapTable from "react-bootstrap-table-next";
import Confirmation from "../../components/Confirmation";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import CustomButton from "../common/CustomButton";
import { GroupContext } from "../../services/contexts/GroupContext";
import {ReactComponent as DeleteIcon} from "../../svg/Delete.svg";
import {ReactComponent as GroupIcon} from "../../svg/GroupIcon.svg";

import classes from "./GroupTable.module.css";
import { truncateWithTooltip } from "../../helpers/common";

function GroupTable() {
  const { SearchBar } = Search;
  const { globalData, deleteGroup } = useContext(GroupContext);
  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const sortCaret = (order) => {
    if (!order) return <span>&nbsp;</span>;
    else if (order === "asc") return <span>↓</span>;
    else if (order === "desc") return <span>↑</span>;
    return null;
  };

  const columns = [
    {
      dataField: "group_name",
      text: "Group List",
      style: { width: "80%" },
      sort: true,
      sortCaret,
      formatter: (cellContent) => {
        return <span>{truncateWithTooltip(cellContent, 85)}</span>;
      },
    },
    {
      dataField: "action",
      text: "Action",
      style: { width: "20%" },
      headerStyle: {
        textAlign: 'center'
     },
      formatter: (cellContent, row) => {
        return (
          <div className={classes.actions_wrapper}>
            <GroupModal
              originalGroupName={row.group_name}
              originalGroupId={row.group_id}
              allowedUsers={row.users}
            />

            <Confirmation
              content={`Please confirm to delete this group: ${row.group_name} ?`}
              Children={
                <CustomButton
                  variant={
                    row.inactive === 1 ? "outline-success" : "outline-danger"
                  }
                  className={classes.delete_button}
                >
                  <DeleteIcon width={26} height={15} className={classes.delete_icon}/>
                </CustomButton>
              }
              onConfirm={() => deleteGroup(row.group_id)}
            />
          </div>
        );
      },
    },
  ];

  function onColumnMatch({ searchText, row }) {
    if (searchText === "") return true;

    const values = Object.values(row)
      .slice(0, 4)
      .map((el) => {
        if (typeof el === "string") {
          return el.toLowerCase();
        } else {
          return el;
        }
      });

    const searchTextArr = searchText?.toString().toLowerCase().split(" ");

    return searchTextArr.every((text) => {
      let included = false;
      values.forEach((val) => {
        if (typeof val === "string") {
          if (val?.includes(text)) included = true;
        } else {
          if (val === text) included = true;
        }
      });
      return included;
    });
  }

  return (
    <>
      <CustomButton
        variant="outline-primary"
        onClick={(e) => {
          e.preventDefault();
          handleShow();
        }}
      className={classes.menu_buttons}
      >
      <GroupIcon width={26} height={14} style={{ margin: "0 3px 3px 0" }}/>
        Groups
      </CustomButton>
      <Modal
        show={show}
        onHide={handleClose}
        className="user-table-modal"
        backdrop="static"
      >
        <ToolkitProvider
          keyField="id"
          data={globalData.allGroups}
          columns={columns}
          search={{
            onColumnMatch,
          }}
        >
          {(props) => (
            <div className={classes.modal_inner}>
              <Modal.Header className="_g-modal-header_">
                <div className="_g-close-button-anchor_">
                  <div className="_g-close-button_" onClick={handleClose}>
                    &#x2715;
                  </div>
                </div>
              </Modal.Header>
              <div
                style={{
                  fontWeight: "700",
                  fontSize: "26px",
                  marginBottom: "15px",
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                <span style={{ margin: "25px 40px" }}>Group &nbsp;&nbsp;&nbsp;</span>

                <div className={classes.group_tool_bar}>
                  <SearchBar {...props.searchProps} className={classes.search_bar}/>
                  <GroupModal />
                </div>
              </div>
              <hr />
              <BootstrapTable
                noDataIndication="Table is Empty"
                striped
                hover
                condensed
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      </Modal>
    </>
  );
}

export default GroupTable;
